export default 'entry'
